import * as React from 'react';
import * as autoBind from 'react-autobind';
import MyWindow from '../../types/MyWindow';

declare const window: MyWindow;

export default class HotKey extends React.Component<HotKeyProps, {}> {
   constructor(props: HotKeyProps) {
      super(props);
      autoBind(this);
   }

   componentDidMount() {
      window.addEventListener('keydown', this.onKeyDown);
   }

   componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyDown);
   }

   onKeyDown(event: KeyboardEvent): void {
      const {character, withAlt, withCtrl, callback} = this.props;

      if (character !== event.key) {
         return;
      }

      if (!this.isValidTarget(event.target as HTMLElement)) {
         return;
      }

      if (!!withAlt !== event.altKey) {
         return;
      }

      if (!!withCtrl !== event.ctrlKey) {
         return;
      }

      callback();
   }

   isValidTarget(target: HTMLElement): boolean {
      const tagName = target.tagName ? target.tagName.toLowerCase() : '';
      return tagName !== 'input' && tagName !== 'textarea';
   }

   render(): any {
      return null;
   }
}

export interface HotKeyProps {
   character: string;
   withAlt?: boolean;
   withCtrl?: boolean;
   callback(): void;
}